/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getContrastColor, setMaxHeightByQuery } from "src/libs/utilities"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { CardsContent, ITimelineCard, SECTION_PROPORTION_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import "../../../../assets/css/cards.scss"
import DataContentEditor from "../../landing-edit/editors/data-content-editor"
import { ICardsProps } from "../Cards"
import Card from "./Card"
import HorizontalTimelineDiagram from "./timeline/HorizontalTimelineDiagram"
  
        
/* Protopia Ecosystem component */
const CardsHorizontalTimeLine = ( props: ICardsProps ): JSX.Element => { 
    const data: CardsContent  = {
        dots: {
            amplitude:0,
            phase:0,
            perimeter: 30,
            stroke_width: 1,
            stroke: "red",
            fill: "var(--force-contast-color)",
            svg_style:{}, 
        },
        ...props.data 
    } 
    const sizes             = useScreenSize()
    const composition       = useComposition(props.section) 
    const is_two_side       = sizes.width >= WINDOW_WIDTH.TABLET && data.is_two_side 
    const cards: ITimelineCard[] = data.cards as ITimelineCard[]
    
    const [height, ]        = useState<string>(getCssDemention( data.height, "fit-content" ))
    
    const alignFields = () => {
        data.card_fields.forEach((field, i) => {
            setMaxHeightByQuery( `.landing-cards-${props.section.id} [data-card-field-id="${i}"]` );
            setMaxHeightByQuery( `.landing-cards-${props.section.id} [data-card-field-id="${i}"] .speech-bubble-content`);
        })
    }
    
    useEffect(() => {
        addCSSClass(
            `landing-h-timeline-cards-${props.section.id}`,
            `
            .landing-cards-container-${data.id} {
                .landing-h-timeline-container {
                    align-items: flex-start;
                }

                .landing-h-timeline-cards-${props.section.id}-left,
                .landing-h-timeline-cards-${props.section.id} {  
                    max-height: ${ height }; 
                    height: ${ height };
                    z-index:1; 
                }
                    
                .landing-h-timeline-cards-${props.section.id}-left {
                    margin-right : 0!important;
                    align-items: flex-end!important;
                }
                .landing-h-timeline {
                    .h-timeline-dot { 
                        color: ${ data.dots.fontColor || getContrastColor( data.dots.color ) }; 
                    }
                }
            }`
        )
        alignFields()  
        return () => { 
            removeCSSClass(`landing-h-timeline-card-${props.section.id}`)
        }
    },[])
       
    useEffect(()=> {
        alignFields()
    }, [ composition, sizes.width ])

    return <div 
        className={`pe-cards-container landing-content-container landing-cards-container-${data.id}`}   
        data-type={data.type} 
        data-content-id={data.id}
    >
        <div className={`landing-h-timeline-container `}>
            {/*  {
                is_two_side && <div className={`landing-h-timeline-cards landing-h-timeline-cards-${props.section.id}-left ${ data.className || "" } `} >
                {
                    Array.isArray(cards) && cards
                    .filter((card, i) => { 
                        return i % 2 === 0
                    })
                    .map((card: ITimelineCard, i: number) =>  { 
                        return <Card
                            key={ card.id }
                            data={ { 
                                ...card, 
                                i  
                            } }
                            contentData={ {
                                ...data,
                                border: {
                                    ...data.border,
                                    noseDistination: SECTION_PROPORTION_TYPE.RIGHT
                                }
                            }}
                            section={ props.section }
                            width={300}
                        />
                    })
                }
                </div>
            }
            */}
            <HorizontalTimelineDiagram {...props} /> 
            <div className={`landing-h-timeline-cards landing-h-timeline-cards-${props.section.id} ${ data.className || "" } `} >
                <div className="timeline-shifter" />
                {
                    Array.isArray(cards) && cards
                    .filter((card, i) => { 
                        return i % 2 === 1 || !is_two_side
                    })
                    .map((card: ITimelineCard, i: number) =>  { 
                        return <Card
                            key={ card.id }
                            data={ { ...card, i } }
                            contentData={  {
                                ...data,
                                border: {
                                    ...data.border,
                                    noseDistination: is_two_side 
                                        ? 
                                        SECTION_PROPORTION_TYPE.LEFT 
                                        : 
                                        SECTION_PROPORTION_TYPE.NONE
                                }
                            } }
                            section={ props.section }
                            width={ 300 }
                        />
                    })
                }
            </div>
        </div>
        <DataContentEditor data={data} section={props.section}  />
    </div>
}
export default CardsHorizontalTimeLine

